import React from 'react'
import { useLocalStorage } from '../../../../../../hooks/useLocalStorage'
import { ToppingWrap } from './index.styled'
import TouchPadContent from './TouchPadContent'
import StandardContent from './StandardContent'

const RestaurantTopping = React.memo(({
	active, item, onClickToppingMinus = () => {
	}, savedOrder, isMenuItem = false, enabledDishCourse, disabled, onClickBackTopping, onClickToppingInfo,
	subItem, subItemIndex,
}) => {
	const [touchPad] = useLocalStorage('touchPad', false)

	const isPreparedToCancel = subItem.status === 'PREPARED_TO_CANCEL'
	const isCanceledSubItem = subItem.status === 'CANCELED'
	const isCanceledItem = ['CANCELED', 'PREPARED_TO_CANCEL'].includes(item?.status)
	const infoAvailable = isCanceledSubItem && subItem.cancellationMetaData
	const layout = (touchPad ? 'touchPad ' : '') + (!disabled && active ? 'active' : '') + (savedOrder ? ' secondary' : '') + (disabled ? ' disabled' : '')

	const commonProps = {
		layout,
		subItem,
		subItemIndex,
		isCanceledSubItem,
		isPreparedToCancel,
		isCanceledItem,
		disabled,
		onClickToppingInfo,
		onClickToppingMinus,
		onClickBackTopping,
		infoAvailable
	}
	return (
		<ToppingWrap key={subItemIndex} className={layout}>

			{touchPad
				? <TouchPadContent {...commonProps} />
				: <StandardContent {...commonProps} />
			}
		</ToppingWrap>)
})

RestaurantTopping.displayName = 'RestaurantTopping'
export default RestaurantTopping
